import { useDispatch } from "react-redux";
import { useGetUnresolvedTicketMessageIdsQuery } from "store/apis/chat";
import { openTicketSlider } from "store/slices/channelInfoSlider";
import { useChannelStateContext } from "stream-chat-react";
import { ChannelInfoWrapper } from "../ChannelInfoWrapper";
import { TicketList } from "./TicketList";

const SmallShimmer = () => (
  <div className="t-h-6 t-animate-pulse t-bg-neutral-20 t-rounded-md t-py-2 t-w-2/5" />
);
const BigShimmer = () => (
  <div className="t-h-6 t-animate-pulse t-bg-neutral-20 t-rounded-md t-py-2 t-w-3/5" />
);

export const ChatTickets = () => {
  const { channel } = useChannelStateContext();
  const dispatch = useDispatch();

  const { data, isLoading } = useGetUnresolvedTicketMessageIdsQuery(
    { channelUrl: channel?.id!, resolved_status: false },
    { skip: !channel?.id, refetchOnMountOrArgChange: true }
  );

  return (
    <ChannelInfoWrapper
      title={
        <div className="t-text-subtext t-flex t-gap-1 t-items-center">
          Tickets
        </div>
      }
      openDetails={() => dispatch(openTicketSlider())}
    >
      {isLoading ? (
        <div className="t-space-y-4">
          <div className="t-flex t-gap-3">
            <SmallShimmer />
            <BigShimmer />
          </div>
          <div className="t-flex t-gap-3">
            <BigShimmer />
            <SmallShimmer />
          </div>
        </div>
      ) : (
        <TicketList
          ticketMessages={data?.ticket_messages || []}
          channelUrl={channel.id!}
          emptyStateText="No tickets"
        />
      )}
    </ChannelInfoWrapper>
  );
};
